angular.module('SpidApp')

.factory('Sale',
[        '_',
function (_) {
	var Sale = function (type, params) {
		params = params || {}

		this.type                  = type
		this.id                    = params.id
		this.label                 = params.label
		this.code_tva              = params.code_tva
		this.price                 = params.price
		this.weight                = params.weight
		this.localPrice            = params.localPrice
		this.equinox               = params.equinox
		this.quantity              = +params.quantity
		this.code_affranchissement = params.code_affranchissement
		this.code_destination      = params.code_destination
		this.transactionId         = params.transactionId
		this.parent                = params.parent
		this.deno_services         = params.deno_services

		this.printStatus = Sale.PRINT_STATUS_PENDING
	}

	Sale.totalPrice = function (arrayOfSales) {
		return _.reduce(arrayOfSales, function (memo, sale) {
			if (sale.type === Sale.REFUND) {
				return memo + -(sale.localPrice * sale.quantity)
			} else {
				return memo + (sale.localPrice * sale.quantity)
			}
		}, 0)
	}
	
	Sale.getSaleProductsOnly = function (arrayOfSales) {
		return _.chain(arrayOfSales).filter(function(sale) {
			return sale.isProduct();
		}).map(function(sale) {
			return sale;
		}).value();
	}

	Sale.REFUND  = 'Refund'
	Sale.STAMP   = 'Stamp'
	Sale.PRODUCT = 'Product'

	Sale.prototype._opQuantity = function (diff) {
		this.quantity = +this.quantity + diff
	}

	Sale.prototype.incrementQuantity = function () {
		this._opQuantity(+1)
	}

	Sale.prototype.decrementQuantity = function () {
		this._opQuantity(-1)
	}

	Sale.prototype.isProduct = function () {
		return this.type === Sale.PRODUCT
	}

	Sale.prototype.isStamp = function () {
		return this.type === Sale.STAMP
	}

	Sale.prototype.isRefund = function () {
		return this.type === Sale.REFUND
	}

	Sale.PRINT_STATUS_REFUNDED = 'refunded'
	Sale.PRINT_STATUS_PENDING  = 'pending'
	Sale.PRINT_STATUS_SUCCESS  = 'success'
	Sale.PRINT_STATUS_FAILURE  = 'failure'
	Sale.prototype.setPrintStatus = function (status) {
		if (!status) {
			throw 'Sale::setPrintStatus() - Missing parameters'
		}

		if (this.type !== Sale.STAMP) {
			throw 'Sale::setPrintStatus() - Trying to set a print status on something not printable'
		}

		if (status === Sale.PRINT_STATUS_PENDING) {
			this.printStatus = Sale.PRINT_STATUS_PENDING

		} else if (status === Sale.PRINT_STATUS_SUCCESS) {
			this.printStatus = Sale.PRINT_STATUS_SUCCESS

		} else if (status === Sale.PRINT_STATUS_FAILURE) {
			this.printStatus = Sale.PRINT_STATUS_FAILURE

		} else if (status === Sale.PRINT_STATUS_REFUNDED) {
			this.printStatus = Sale.PRINT_STATUS_REFUNDED

		} else {
			throw 'Sale::setPrintStatus() - Malformed parameters'
		}
	}

	Sale.prototype.getPrintStatus = function () {
		return this.printStatus
	}

	return Sale
}])